import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import BetaNavbar from "./components/BetaNavbar";
import AdminHeroSection from "./components/SuperUserDashboard/AdminHeroSection";
import AdminTabbedSection from "./components/SuperUserDashboard/AdminTabbedSection";
import betaAPI from "v2/api";

const SuperUserDashboard = () => {
  const { t } = useTranslation();
  // Raw system-wide counts from /overview/ (one request), shared by the header
  // cards and the tab badges.
  const [counts, setCounts] = useState({
    workspaces: 0,
    users: 0,
    teams: 0,
    athletes: 0,
    wearables: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOverview = async () => {
      try {
        setLoading(true);
        const res = await betaAPI.getAdminOverview();
        if (res.data) setCounts((prev) => ({ ...prev, ...res.data }));
      } catch (error) {
        console.error("Failed to fetch admin overview:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchOverview();
  }, []);

  const stats = {
    totalWorkspaces: counts.workspaces,
    totalUsers: counts.users,
    totalTeams: counts.teams,
    totalPlayers: counts.athletes,
    wearables: counts.wearables,
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-[#F8F9FA]">
        <BetaNavbar hideWorkspaceSelector />
        <div className="flex items-center justify-center py-20">
          <div className="text-sm text-[#6B7280]">
            {t("admin.superUser.loadingDashboard")}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen overscroll-none bg-[#F8F9FA]">
      <BetaNavbar hideWorkspaceSelector />

      <main>
        {/* Hero Section with gradient */}
        <div
          style={{
            background:
              "linear-gradient(180deg, rgba(232, 133, 74, 0.08) 0%, rgba(232, 133, 74, 0.03) 50%, rgba(255, 255, 255, 0) 100%)",
          }}
        >
          <div className="mx-auto max-w-[1440px]">
            <AdminHeroSection stats={stats} />
          </div>
        </div>

        {/* Content section */}
        <div className="mx-auto max-w-[1440px] px-6 pb-6">
          <AdminTabbedSection counts={counts} />
        </div>
      </main>
    </div>
  );
};

export default SuperUserDashboard;
